import useBrandConfig from "../../utils/hooks/useBrandConfig";

const HomePageFooter = () => {
  const { isPaysonic } = useBrandConfig();

  return (
    <footer
      className="py-4 mt-auto flex justify-center"
      style={{ visibility: isPaysonic ? "hidden" : "visible" }}
    >
      <nav className="flex flex-wrap justify-center gap-2 md:gap-4 text-center">
        <a
          href="https://tylt.money/privacy-policy-row"
          className="text-[8px] md:text-[10px] underline break-words"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
        <a
          href="https://tylt.money/cookie-policy-row"
          className="text-[8px] md:text-[10px] underline break-words"
          target="_blank"
          rel="noreferrer"
        >
          Cookie Policy
        </a>
        <a
          href="https://tylt.money/terms-of-use-row"
          className="text-[8px] md:text-[10px] underline break-words"
          target="_blank"
          rel="noreferrer"
        >
          Terms of Use
        </a>
        <a
          href="https://tylt.money/merchant-terms-of-use-copy-row"
          className="text-[8px] md:text-[10px] underline break-words"
          target="_blank"
          rel="noreferrer"
        >
          Merchant Terms of Use
        </a>
        <a
          href="https://tylt.money/risk-disclaimer-row"
          className="text-[8px] md:text-[10px] underline break-words"
          target="_blank"
          rel="noreferrer"
        >
          Risk Disclaimer
        </a>
      </nav>
    </footer>
  );
};

export default HomePageFooter;